<template lang="pug">
  form.form-booking(v-on:submit.prevent="submit")
    .form-booking__form-inputs
      input.js-form-booking-event-id(type="hidden", name="eventId")
      .form-booking__form-left
        PatternInput(class="form-booking__input", :regExp="setting.regExp", :replacement="setting.replacement" v-model="name" placeholder="Имя *" required autocomplete="off")
        input.form-booking__input(v-model="phone" v-mask="'+7(###)-###-##-##'" type="text" name="phone" placeholder="Телефон *" required autocomplete="off")
      .form-booking__form-right
        Datepicker(
          :language="ru",
          input-class="form-booking__input",
          wrapper-class="form-booking__date-wr",
          calendar-class="vue-date-picker",
          placeholder="Дата",
          :format="customFormatter",
          v-model="date",
          :disabled-dates="disabledDates")
        input.form-booking__input(v-model="guests" type="number" min="1" name="guests" placeholder="Кол-во гостей" autocomplete="off")
    .form-booking__form-btn-wr
      button.form-booking__form-btn-send(type="submit")
        | Забронировать
      .form-booking__form-agreement
        | Нажимая кнопку «Отправить»,
        a.form-booking__form-agreement-link(target="_blank" href="/privacy-policy") Вы даете согласие на обработку персональных данных
</template>

<script>
import {AjaxHelpersVue} from '@/mixins/AjaxHelpersVue';
import {PopupHelpersVue} from '@/mixins/PopupHelpersVue';

import Datepicker from 'vuejs-datepicker';
import {ru} from 'vuejs-datepicker/dist/locale'

import PatternInput from 'vue-pattern-input';

export default {
  name: "EventItem",

  mixins: [AjaxHelpersVue, PopupHelpersVue],

  props: {},

  data() {
    return {
      name: '',
      phone: '',
      date: '',
      guests: '',
      ru,
      setting: {
        regExp: /\d/,
        replacement: '',
      }
    }
  },

  components: {
    Datepicker,
    PatternInput
  },

  computed: {
    disabledDates() {
      const todayStart = new Date();
      todayStart.setHours(0, 0, 0, 0);
      return {
        to: new Date(todayStart.getTime() - 1)
      };
    }
  },

  methods: {

    customFormatter(date) {
      moment.locale('ru');

      return moment(date).format('L');
    },

    submit() {
      let $eventId = $('.js-popup-booking').find('.js-form-booking-event-id');

      let data = {
        name: this.name,
        phone: this.phone,
        date: moment(this.date).format('L'),
        guests: this.guests,
        eventId: $eventId.val() || ''
      };

      this.req('Booking:reserveVisit', data, res => {
        this.popupLocal('booking', 'close');

        this.popupLocal('popupMessage', 'show');

        if (this.checkProperty(res.status)) {
          if (res.status === 'ok') {
            dataLayer.push({'event': 'formsend'});
            this.name = '';
            this.phone = '';
            this.date = '';
            this.guests = '';
            $eventId.val('');
          }
        }
      });
    },

    popupLocal(type, action) {
      this.popup(type, action);
    }
  }
}
</script>

<style>
.form-booking__form-agreement-link{
  text-decoration: underline;
  cursor: pointer;
  transition: color .25s linear;
}

.form-booking__form-agreement-link:hover{
  color: #62b6f2;
}
</style>
